import { config } from '@js/index';
import { disablePointerEvents, enablePointerEvents } from '@utils/pointer-events-control';

// shared audio bag — populated here, consumed in GameScene/LV2 scenes.
// Preserve any pre-existing keys (e.g. disableWebAudio) on config.audio.
if (!config.audio) config.audio = {};

let cam;
let complete = 0;

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'StartScene',
    });
  }

  preload() {}

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();

    this.BG = this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      'BG',
    );
    this.play = this.add.image(640, 500, 'play').setInteractive({ cursor: 'pointer' });
    this.cloud = this.add.image(1400, 200, 'cloud');

    // cloud movement
    this.tweens.add({
      targets: this.cloud,
      x: -200,
      duration: 90000,
      ease: 'Power1',
      repeat: -1,
      yoyo: true,
    });

    // truck animation
    this.anims.create({
      key: 'truckDrive',
      frames: this.anims.generateFrameNames('truckDrive', {
        start: 0,
        end: 163,
        zeroPad: 0,
        prefix: 'truckDrive',
        suffix: '.png',
      }),
      frameRate: 15,
      repeat: 0,
    });

    // front trees
    this.anims.create({
      key: 'frontTree',
      frames: this.anims.generateFrameNames('frontTree', {
        start: 0,
        end: 140,
        zeroPad: 0,
        prefix: 'trees_front',
        suffix: '.png',
      }),
      frameRate: 25,
      repeat: -1,
    });

    // back trees
    this.anims.create({
      key: 'backTree',
      frames: this.anims.generateFrameNames('backTree', {
        start: 0,
        end: 140,
        zeroPad: 0,
        prefix: 'trees_back',
        suffix: '.png',
      }),
      frameRate: 25,
      repeat: -1,
    });

    // birds
    this.anims.create({
      key: 'birdFly',
      frames: this.anims.generateFrameNames('birdFly', {
        start: 0,
        end: 369,
        zeroPad: 0,
        prefix: 'birdsAnim',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.birdFly = this.add.sprite(700, 400, 'birdFly').play('birdFly');
    this.backTree = this.add.sprite(640, 360, 'backTree').play('backTree');
    this.bottom1 = this.add.image(640, 600, 'bottom1');
    this.frontTree = this.add.sprite(640, 355, 'frontTree').play('frontTree');
    this.truckDrive = this.add.sprite(640, 349, 'truckDrive').play('truckDrive');
    this.bottom2 = this.add.image(640, 643, 'bottom2');

    this.truckDrive.on(
      Phaser.Animations.Events.ANIMATION_COMPLETE,
      () => {
        complete = 1;
      },
      this,
    );

    cam = this.cameras.main;

    this.play.on(
      'pointerover',
      () => {
        this.play.setTexture('playBlack');
      },
      this,
    );

    this.play.on(
      'pointerout',
      () => {
        this.play.setTexture('play');
      },
      this,
    );

    this.play.on(
      'pointerdown',
      () => {
        enablePointerEvents();
        this.play.setVisible(false);

        config.audio.BirdsWingBG = this.sound
          .add('BirdsWingBG')
          .setVolume(0.15)
          .setLoop(true);
        config.audio.BirdsWingBG.play();

        config.audio.mainBG = this.sound.add('mainBG').setVolume(0.3).setLoop(true);
        config.audio.mainBG.play();

        if (complete === 0) {
          this.tweens.add({
            targets: this.truckDrive.anims,
            timeScale: { from: 0.5, to: 2.8 },
            ease: 'Sine.easeInOut',
            yoyo: false,
            repeat: 0,
            delay: 2,
            duration: 40,
          });

          this.truckDrive.on(
            Phaser.Animations.Events.ANIMATION_COMPLETE,
            () => {
              this.sceneChange();
            },
            this,
          );
        }

        if (complete === 1) this.sceneChange();
      },
      this,
    );
  }

  sceneChange() {
    cam.fadeOut(500, 255, 255, 255);
    cam.once(
      'camerafadeoutcomplete',
      () => {
        this.scene.start('GameScene');
      },
      this,
    );
  }

  update() {}
}
